import { render, staticRenderFns } from "./vodMasthead.vue?vue&type=template&id=05e24b6e&scoped=true&"
import script from "./vodMasthead.vue?vue&type=script&lang=js&"
export * from "./vodMasthead.vue?vue&type=script&lang=js&"
import style0 from "./vodMasthead.vue?vue&type=style&index=0&id=05e24b6e&scoped=true&lang=css&"
import style1 from "./vodMasthead.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e24b6e",
  null
  
)

export default component.exports